export const homePageId = 'homepage';
export const categoryPageId = 'category-page';
export const searchResultsPageId = 'search-results';
export const appPageId = 'app-page';
